// Modified from https://github.com/codrops/MultiLevelPushMenu/blob/master/js/mlpushmenu.js

(function($) {
    var $pusher = $('.menu-wrapper__pusher'),
        $curtain = $('.menu-wrapper__curtain'),
        $toggler = $("[data-toggle='menu']"),
        $menu = $('.menu'),
        menuWidth = $('.menu').width(),
        $currentMenu = null,
        dragging = false,
        prevPageX = null,
        dragStartX = null,
        pM = 0;

    var methods = {
        init: function(options) {
            var self = this;

            // Prepare for use with PEP polyfill
            $menu.attr('touch-action', 'none');
            $curtain.attr('touch-action', 'none');

            $toggler.on('pointerup', function(e) {
                e.stopPropagation();
                e.preventDefault();

                var m = $(e.target).data('target');
                var $m = $(m);

                if ($m.data('open') == true) {
                    methods.close();
                } else {
                    methods.open($m);
                }
            });

            $(document).on('pointerdown', function(e) {
                // If this event was fired inside a menu
                if ($(e.target).closest('.menu')[0] && !$(e.target).closest('.nstSlider')[0]) {
                    dragging = true;

                    dragStartX = e.pageX;
                }
            });

            $(document).on('pointermove', function(e) {
                if (dragging) {
                    // Get current translateX value
                    if ($currentMenu) {
                        var tX = getTranslateX($currentMenu);

                        // Find distance between events
                        prevPageX = prevPageX || e.pageX;
                        var pX = prevPageX - e.pageX;

                        // Calculate the amount to translate the menu (multiplied by two to increase responsiveness)
                        var mX = Math.max(Math.min(tX - pX * 2, 0), -menuWidth);

                        // Update the matrix transformation
                        $currentMenu.css({
                            transform: 'matrix(1, 0, 0, 1, ' + mX + ', 0)'
                        });

                        prevPageX = e.pageX;
                    }
                }
            });

            $(document).on('pointerup', function(e) {
                // Stop dragging
                dragging = false;

                var $m = $(e.target).closest('.menu');

                // If this was fired outside the menu or on a close button
                if (!$m[0] || $(e.target).is('[data-dismiss]')) {
                    // Make sure a menu is open and we're not at the end of a swipe
                    if ($currentMenu && dragging === false) {
                        e.stopPropagation();
                        e.preventDefault();

                        // Close menu
                        methods.close();
                    }

                    // If this was fired inside the menu
                } else if ($m[0]) {
                    // Get current translateX value
                    // Find distance between start and end of drag
                    var dX = dragStartX - e.pageX;

                    // Snap menu open or closed
                    if (dX > 150) {
                        methods.close();
                    } else {
                        $m.css({
                            transform: 'translate3d(0, 0, 0)'
                        });
                    }
                }

                // Reset dragStartX and prevPageX
                dragStartX = null;
                prevPageX = null;
            });
        },
        open: function($m) {
            $m = $m || $currentMenu;

            $pusher.addClass('pushed');
            $('html').addClass('lock');
            if ($m) {
                $m.css({
                    transform: 'translate3d(0, 0, 0)'
                }).data('open', true);
            }

            $currentMenu = $m;
        },
        close: function($m) {
            $m = $m || $currentMenu;
            if ($m) {
                $m.css({
                    transform: 'translate3d(-100%, 0, 0)'
                })
                    .removeClass('open')
                    .data('open', false);
            }
            $pusher.removeClass('pushed');
            $('html').removeClass('lock');

            $currentMenu = null;
        }
    };

    $.fn.offCanvasMenu = function(methodOrOptions) {
        if (methods[methodOrOptions]) {
            let callCall;
            if (Array.prototype.slice) {
                callCall = Array.prototype.slice.call(arguments, 1);
            }
            return methods[methodOrOptions].apply(this, callCall);
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.tooltip');
        }
    };

    function getTranslateX($m) {
        // Gets the translateX value from the current transformation matrix
        if ($m) {
            var t = $m.css('transform').split(',')[4];
            return parseInt(t, 10);
        }
    }
})(jQuery);
